import { useTranslation } from 'react-i18next'

import { Callout } from '../Typography/Callout'

import './AppStatusBadge.scss'

type FeatureDisabledProps = {
  featuresDisabled: string[]
}

/**
 * @private This component is only to use in the AppStatusBadge component
 */
export const FeatureDisabled = ({ featuresDisabled }: FeatureDisabledProps) => {
  const { t } = useTranslation()
  if (!featuresDisabled.length) {
    return null
  }

  return (
    <Callout className="text-current" variant="callout1">
      {t('AppStatusBadgeDescription')}
      <ul>
        {featuresDisabled.map((feature, index) => {
          return (
            <li>
              <span key={index} className="feature">
                - {t('AppStatusBadgeFeature_' + feature)}
              </span>
            </li>
          )
        })}
      </ul>
    </Callout>
  )
}
